import videojs from 'video.js';
import SharingButtons from './sharing-buttons.js';
import SharingButton from './sharing-button.js';
import SharingOptions from './sharing-options.js';
import SRGSocialSharing from '../../../utils/SRGSocialSharing.js';
import Utils from '../../../utils/Utils.js';

const Component = videojs.getComponent('Component');

/**
 * LetterBoxWeb social sharing component
 * @ignore
 */
class SharingContainer extends Component {
  constructor(player, options) {
    super(player, options);

    this.hasBeenPausedBefore = false;
    this.socialSharingStrategy = new SRGSocialSharing(
      player,
    );
    this.hide();

    this.createChildren();
  }

  reset(socialSharing, shouldHideOptions) {
    this.socialSharing = socialSharing;

    if (shouldHideOptions) {
      this.getChild('sharingOptions').hide();
    } else {
      this.getChild('sharingOptions').show();
    }

    this.getChild('sharingOptions')
      .children()
      .forEach((option) => {
        if (option.name() === SRGSocialSharing.SHARING_MODES.FULL_LENGTH) {
          option.handleClick();
        }

        option.update();
      });
  }

  show() {
    this.removeClass('sharing-container--hidden');
    this.options().parent.addClass('sharing-module--opened');
    Utils.hideFromAccessibility(false, this.el());
    this.setFocusToFirstElement();
    // We don't want to resume the media if the user paused it by himself
    this.hasBeenPausedBefore = this.player().paused();

    if (!this.player().paused()) {
      this.player().pause();
    }
  }

  hide() {
    this.addClass('sharing-container--hidden');
    Utils.hideFromAccessibility(true, this.el());
    this.options().parent.removeClass('sharing-module--opened');

    if (this.player().hasStarted() && this.player().paused() && !this.hasBeenPausedBefore) {
      this.player().play();
    }
  }

  /**
   * Sets the focus to thr first item
   */
  setFocusToFirstElement() {
    const nextFocusableItem = Utils.getKeyboardFocusableElements(this.el());
    if (nextFocusableItem && nextFocusableItem.length > 0) {
      nextFocusableItem[0].focus();
    }
  }

  createEl() {
    const el = super.createEl('div', {
      className: 'sharing-container sharing-container--hidden',
    });

    return el;
  }

  createChildren() {
    this.addChild(
      new SharingButton(
        this.player(),
        {
          name: 'close',
          controlText: this.localize('Close'),
          className: 'sharing-container__close',
          icon: 'close',
          onClick: () => {
            this.hide();
            this.options().parent.getChild('sharingButton').focus();
          },
        },
      ),
    );

    this.addChild(new Component(
      this.player(),
      {
        name: 'containerTitle',
        el: videojs.dom.createEl('h1', {
          className: 'sharing-container__title',
          innerHTML: this.localize('Share'),
        }),
      },
    ));

    this.addChild(new SharingOptions(
      this.player(),
      {
        name: 'sharingOptions',
        socialSharingStrategy: this.socialSharingStrategy,
      },
    ));

    this.addChild(new SharingButtons(
      this.player(),
      {
        socialSharing: () => this.socialSharing,
        socialSharingStrategy: this.socialSharingStrategy,
      },
    ));
  }
}

Component.registerComponent('SharingContainer', SharingContainer);
export default SharingContainer;
